import { wizardStepPageTitleStyle, wizardStepPageSubtitleStyle } from './wizardTypography';

function StepHeader({ title, description, titleActions, className = '' }) {
    if (!title && !description) return null;

    return (
        <header className={`px-6 pt-8 pb-4 md:px-10 ${className}`.trim()}>
            {title && (
                <div className="mb-2 flex items-center gap-2">
                    <h1 style={wizardStepPageTitleStyle}>{title}</h1>
                    {titleActions}
                </div>
            )}
            {description && (
                <p style={wizardStepPageSubtitleStyle}>{description}</p>
            )}
        </header>
    );
}

/**
 * Wizard step shell.
 * Default: single scroll column (header + body + footer in flow, per v7 in-content .modal-footer).
 * bodyAsFlex: fixed header / flex map body / pinned footer (geofence step).
 */
const WizardStepLayout = ({ title, description, children, footer, bodyAsFlex = false, titleActions }) => {
    if (bodyAsFlex) {
        return (
            <div className="flex min-h-0 flex-1 flex-col">
                <StepHeader
                    title={title}
                    description={description}
                    titleActions={titleActions}
                    className="shrink-0"
                />
                <div className="min-h-0 flex-1 flex flex-col px-6 md:px-10">
                    {children}
                </div>
                {footer && (
                    <footer className="shrink-0 px-6 pb-6 md:px-10">
                        {footer}
                    </footer>
                )}
            </div>
        );
    }

    return (
        <div className="min-h-0 flex-1 overflow-y-auto overscroll-contain">
            <StepHeader title={title} description={description} titleActions={titleActions} />
            <div className="px-6 md:px-10">
                {children}
            </div>
            {footer && (
                <footer className="px-6 pb-6 md:px-10">
                    {footer}
                </footer>
            )}
        </div>
    );
};

export default WizardStepLayout;
